import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class UserSettingManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-app/user-settings',
      params,
      paramsSerializer: qs.stringify,
    });
}
